import React, { useState, useEffect, Fragment } from 'react';
import { FaRegFile } from 'react-icons/fa';
import { MdDone } from 'react-icons/md';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import Skeleton from 'react-loading-skeleton';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import useFetchVesselDocuments from '../Utils/useFetchVesselDocuments';

const VesselsDocs = ({ vesselId }) => {
  const { data, loading, isError, error } = useFetchVesselDocuments(vesselId);
  const { documents } = data?.data || {};
  const [collapsedSections, setCollapsedSections] = useState({ vesselDoc: true });
  
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);

  const toggleSection = (section) => {
    setCollapsedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const handleViewPdf = (url) => {
    setIsLoadingPdf(true);
    setPdfUrl(url);
    setShowModal(true);
  };

  useEffect(() => {
    if (pdfUrl) {
      const timer = setTimeout(() => setIsLoadingPdf(false), 1000); // Simulate loading time
      return () => clearTimeout(timer);
    }
  }, [pdfUrl]);

  const closeModal = () => {
    setShowModal(false);
    setPdfUrl('');
  };

  return (
    <Fragment>
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {isLoadingPdf ? (
              <p>Loading document...</p>
            ) : (
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                <Viewer fileUrl={pdfUrl} />
              </Worker>
            )}
          </div>
          <button className="close-btn" onClick={closeModal}>
            Close
          </button>
        </div>
      )}

      <div className="myvessel-details-container">
        <div className="info" onClick={() => toggleSection('vesselDoc')}>
          <p>Vessel Documents</p>
          {collapsedSections.vesselDoc ? <IoIosArrowDown /> : <IoIosArrowUp />}
        </div>

        {!collapsedSections.vesselDoc && (
          <div className="card">
            {loading ? (
              <>
                <Skeleton count={1} height={30} width={300} style={{ marginBottom: '20px' }} />
                <Skeleton count={3} height={200} />
              </>
            ) : isError ? (
              <div>Error: {error.message}</div>
            ) : (
              <>
                {documents && (
                  <>
                    {documents.specSheet && (
                      <div className="file-preview">
                        <div className="first">
                          <FaRegFile className="file" />
                          <span>Spec Sheet {documents.specSheet.size}</span>
                        </div>
                        <div className="second">
                          <MdDone className="done" />
                          <button
                            className="view-link"
                            onClick={() => handleViewPdf(documents.specSheet)}
                          >
                            View
                          </button>
                        </div>
                      </div>
                    )}

                    {documents.bollardPullCertificate && (
                      <div className="file-preview">
                        <div className="first">
                          <FaRegFile className="file" />
                          <span>Bollard Pull Certificate {documents.bollardPullCertificate.size}</span>
                        </div>
                        <div className="second">
                          <MdDone className="done" />
                          <button
                            className="view-link"
                            onClick={() => handleViewPdf(documents.bollardPullCertificate)}
                          >
                            View
                          </button>
                        </div>
                      </div>
                    )}

                    {documents.navyCertificate && (
                      <div className="file-preview">
                        <div className="first">
                          <FaRegFile className="file" />
                          <span>Navy Certificate {documents.navyCertificate.size}</span>
                        </div>
                        <div className="second">
                          <MdDone className="done" />
                          <button
                            className="view-link"
                            onClick={() => handleViewPdf(documents.navyCertificate)}
                          >
                            View
                          </button>
                        </div>
                      </div>
                    )}

                    {!documents.specSheet &&
                      !documents.bollardPullCertificate &&
                      !documents.navyCertificate && (
                        <p className="images-error">No documents available</p>
                      )}
                  </>
                )}
                {!documents && <p className="images-error">No documents available</p>}
              </>
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default VesselsDocs;

